document.addEventListener("DOMContentLoaded", () => {
  console.log("jbl-swatches loaded");

  const getCardMediaImgs = (card) => {
    if (!card) return [];
    const media = card.querySelector(".card__media");
    if (!media) return [];
    return Array.from(media.querySelectorAll("img"));
  };

  const saveOriginal = (img) => {
    if (!img) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.getAttribute("src") || "";
      img.dataset.originalSrcset = img.getAttribute("srcset") || "";
      img.dataset.originalSizes = img.getAttribute("sizes") || "";
    }
  };

  const setImg = (img, url) => {
    if (!img || !url) return;
    const clean = url.replace(/&amp;/g, "&");
    saveOriginal(img);
    img.setAttribute("src", clean);
    img.setAttribute("srcset", `${clean} 720w`);
  };

  const restoreImg = (img) => {
    if (!img) return;
    const oSrc = img.dataset.originalSrc || "";
    const oSrcset = img.dataset.originalSrcset || "";
    const oSizes = img.dataset.originalSizes || "";
    if (oSrc) img.setAttribute("src", oSrc);
    if (oSrcset) img.setAttribute("srcset", oSrcset);
    if (oSizes) img.setAttribute("sizes", oSizes);
  };

  const applyVariantImage = (card, imgUrl) => {
    const imgs = getCardMediaImgs(card);
    if (!imgs.length) {
      const main = card.querySelector("[data-card-main-image]") || card.querySelector("img");
      if (main) setImg(main, imgUrl);
      return;
    }
    imgs.forEach((img) => setImg(img, imgUrl));
  };

  const restoreOriginal = (card) => {
    const imgs = getCardMediaImgs(card);
    if (!imgs.length) {
      const main = card.querySelector("[data-card-main-image]") || card.querySelector("img");
      if (main) restoreImg(main);
      return;
    }
    imgs.forEach((img) => restoreImg(img));
  };

  document.body.addEventListener("pointerover", (e) => {
    const swatch = e.target.closest(".card__swatch");
    if (!swatch) return;
    const card = swatch.closest(".card");
    if (!card) return;
    const imgUrl = swatch.getAttribute("data-variant-image");
    if (!imgUrl) return;
    applyVariantImage(card, imgUrl);
  });

  document.body.addEventListener("pointerout", (e) => {
    const swatches = e.target.closest(".card__swatches");
    if (!swatches) return;
    if (e.relatedTarget && swatches.contains(e.relatedTarget)) return;
    const card = swatches.closest(".card");
    if (!card) return;
    restoreOriginal(card);
  });
});